module.exports = __webpack_public_path__ + "static/assets/36b59d3087103cc7573145332ec64745.svg";